import React from 'react';
import * as styles from './style';
import Chip from '../Chip';
import {IconButton} from '../IconButton';
import LoadingBar from '../Controls/LoadingBar';
import Tooltip from '@mui/material/Tooltip';
import {Text} from '../../utils/style/texts';
import {Flex} from "../Container/Flex";
import PrimaryButton from "../Controls/PrimaryButton";
import TextButton from "../Controls/TextButton";

const Overlay = props => {

    const {chipText, chipColor, title, loading, children, actions, buttons, ...other} = props;
    return (
        <styles.Wrapper ref={props.innerRef} {...other}>
            <Flex col fullWidth style={{flex: 1, height: buttons?.length > 0 ? 'calc(100% - 40px)' : '100%'}}>
                <styles.TopBar>
                    <styles.StateWrapper>
                        {chipColor && (<Chip color={chipColor} label={chipText}/>)}
                        <Text>{title}</Text>
                    </styles.StateWrapper>
                    <styles.Actions>
                        {actions && actions.map((a, i) => {
                            if (a.component) return <div key={i}>{a.component}</div>;
                            const btn = (
                                <IconButton disabled={a.disabled} key={i} onClick={() => a.onClick()} size="large">
                                    <a.icon/>
                                </IconButton>
                            );
                            return a.title ? <Tooltip key={i} title={a.title}>
                                <div>{btn}</div>
                            </Tooltip> : btn;
                        })}
                    </styles.Actions>
                </styles.TopBar>
                {loading ? (
                    <LoadingBar/>
                ) : <styles.Content hasButtons={!!buttons?.length}>{children}</styles.Content>}
            </Flex>
            {!!buttons?.length && (
                <styles.Buttons elevation={5}>
                    {buttons.map(({type, icon, title, style, ...other}) => {
                        const B = type === 'primary' ? PrimaryButton : TextButton;
                        const Icon = icon;
                        return (
                            <B key={title} style={{marginRight: 4, ...style}} {...other}>
                                <Icon />&nbsp;
                                {title}
                            </B>
                        )
                    })}
                </styles.Buttons>
            )}
        </styles.Wrapper>
    );
};

export default Overlay;